import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Library Overview</h2>
      <p>
        Welcome to your Business Kitz Document Library. This space is organised into key folders to
        help you quickly find and download the documents you need.
      </p>
      <h2>Using the Library:</h2>
      <p>Choose from the categories:</p>
      <ul>
        <li>
          <strong>Business:&nbsp;</strong>General operations, compliance, admin tools.
        </li>
        <li>
          <strong>Employment:&nbsp;</strong>Contracts, onboarding forms, HR policies.
        </li>
        <li>
          <strong>Customers:&nbsp;</strong>Agreements, service terms, communication templates.
        </li>
        <li>
          <strong>Suppliers:&nbsp;</strong>Purchase agreements, onboarding docs, T&Cs.
        </li>
      </ul>
      <h2>Browse Documents:</h2>
      <p>
        Inside each folder, you’ll find a list of templates tailored to that category. Use the
        search bar to find a specific document by name.
      </p>
      <h2>Download and Edit:</h2>
      <p>
        All templates are downloadable in Word format. Once downloaded, you can customise the
        document to suit your business needs.
      </p>
      <p>
        <strong>Tip:&nbsp;</strong>Use filters at the top to switch between “Business Kitz Library”
        and your own saved documents.
      </p>
    </div>
  );
};

export default Preview;
